import { useState } from 'react';
import { EmojiHappy, EmojiOkay, EmojiSad, EmojiSoHappy, EmojiSoSad } from '../../images/emojis';
import { Colors } from '../../themes/colors';
import { Center } from '../Center';
import { Column } from '../Column';
import { Row } from '../Row';
import { Text } from '../Text';

type TEmojiKey = 'soSad' | 'sad' | 'okay' | 'happy' | 'soHappy';

type TEmojiItem = {
  key: TEmojiKey;
  title: string;
  value: number;
  Component: React.ComponentType<{ selected: boolean }>;
};

const emojis: TEmojiItem[] = [
  { key: 'soSad', title: 'Yikes!', value: 1, Component: EmojiSoSad },
  { key: 'sad', title: 'Meh', value: 2, Component: EmojiSad },
  { key: 'okay', title: 'Okay', value: 3, Component: EmojiOkay },
  { key: 'happy', title: 'Sweet', value: 4, Component: EmojiHappy },
  { key: 'soHappy', title: 'Fantastic!', value: 5, Component: EmojiSoHappy },
];

export type TEmojiSelectionValue = {
  key: TEmojiKey | null;
  title: string | null;
  value: number | null;
};

interface IEmojiSelectionProps {
  onSelect: (value: TEmojiSelectionValue) => void;
}

export const EmojiSelection = ({ onSelect }: IEmojiSelectionProps) => {
  const [selectedEmoji, setSelectedEmoji] = useState<TEmojiKey | null>(null);

  const handleSelect = (key: TEmojiKey, title: string, value: number) => {
    const isSelected = selectedEmoji === key;
    setSelectedEmoji(isSelected ? null : key);
    onSelect(isSelected ? { key: null, title: null, value: null } : { key, title, value });
  };

  return (
    <Row>
      {emojis.map(({ key, Component, title, value }) => (
        <EmojiWrapper
          key={key}
          Emoji={Component}
          isSelected={selectedEmoji === key}
          onClick={() => handleSelect(key, title, value)}
          title={title}
        />
      ))}
    </Row>
  );
};

interface IEmojiWrapperProps {
  Emoji: React.ComponentType<{ selected: boolean }>;
  isSelected: boolean;
  onClick: () => void;
  title: string;
}

const EmojiWrapper = ({ Emoji, isSelected, onClick, title }: IEmojiWrapperProps) => (
  <Column
    onClick={onClick}
    width={68}
    height={84}
    style={{
      cursor: 'pointer',
    }}
  >
    <Center>
      <Emoji selected={isSelected} />
      {isSelected && (
        <Text fontSize={18} bold color={Colors.secondary_500}>
          {title}
        </Text>
      )}
    </Center>
  </Column>
);
